import React, { useRef, useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addStyles } from "react-mathquill";
import _ from "lodash";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setAnswerEditorAction, clearAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";

const AnswerEditorController = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };
  const clearAnswerEditor = () => { dispatch( clearAnswerEditorAction() ) };

  const mathField = useRef();

  useEffect( () => {
    return () => {
      setTimeout( clearAnswerEditor );
    };
  }, [] );

  useEffect( () => {
    answeringQuestions.data.qstCd && answeringQuestions.keypadType && clearAnswerEditor();
  }, [ answeringQuestions.data.qstCd, answeringQuestions.keypadType ] );

  useEffect( () => {
    if ( answerEditor.isShow ) {
      mathField.current.latex( '' );
      mathField.current.focus();
    } else {
      mathField.current.latex( answeringQuestions.answer[ answeringQuestions.answerIndex ] );
    }
  }, [ answerEditor.isShow ] );

  useEffect( () => {
    if ( answerEditor.answerKey ) {
      const { answerKey, answers } = answerEditor;
      let answer = '';
      // selvas에서 받는 데이터 값이면
      if (answerKey.split('?')[0] && answers?.length > 1) {
        // console.log({ data: answeringQuestions.data, answerIndex: answeringQuestions.answerIndex});
        const qstCransr = answeringQuestions?.data?.qstCransr.split(';');
        const index = _.indexOf(answers, qstCransr[answeringQuestions.answerIndex]);
        answer = index > -1 ? `${answers[index]}` : answers[0];
        answer = [answer, 'overwrite'];
      } else {
        answer = answerKey.split('?');
      }

      /**
       * overwrite가 붙어 있을 때는 필기패드, 없을 때는 키패드 인듯.
       */
      'overwrite' === answer[1] ? mathField.current.latex(answer[0]) : setMathField(answer[0]);
      !answerEditor.isShow && setAnswer();

    } else {
      mathField.current.latex( '' );
    }
  }, [ answerEditor.answerKey ] );

  const setMathField = ( answerKey ) => {
    switch ( answerKey ) {
      case TYPE.KEY_STROKE.LEFT :
      case TYPE.KEY_STROKE.RIGHT :
      case TYPE.KEY_STROKE.BACKSPACE :
        mathField.current.keystroke( answerKey );
        break;
      default :
        mathField.current.write( answerKey );
        answerEditor.cursor && moveCursor();
    }
  };

  const moveCursor = () => {
    const move = ( value ) => {
      '<' === value ? mathField.current.keystroke( TYPE.KEY_STROKE.LEFT ) : mathField.current.keystroke( TYPE.KEY_STROKE.RIGHT );
    };
    answerEditor.cursor.split( ';' ).map( move );
  };

  const setAnswer = () => {
    setAnsweringQuestions( { answer : answeringQuestions.answer.map( ( v, i ) => answeringQuestions.answerIndex === i ? mathField.current.latex() || '\\phantom{0}' : v ) } );
  };

  const mountEditableMathField = ( bare ) => {
    bare.__controller.textarea[ 0 ].setAttribute( 'inputmode', 'none' );
    mathField.current = bare;
    addStyles();
  };

  const reset = () => {
    mathField.current.latex( '' );
    mathField.current.keystroke( TYPE.KEY_STROKE.LEFT );
  };

  const submit = () => {
    const latex = mathField.current.latex();
    mathField.current.latex( answeringQuestions.answer[ answeringQuestions.answerIndex ] );
    setAnswerEditor( { answerKey : `${ mathField.current.latex() }${ latex }?overwrite` } );
    hide();
  };

  const hide = () => {
    setAnswerEditor( { isShow : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onMount : mountEditableMathField,
    onReset : reset,
    onSubmit : submit,
    onHide : hide
  } );

};

export default AnswerEditorController;
